import cls from "classnames";
import { TransferCalcRound, TransferStatus } from "./enums";

const transferLink = import.meta.env.VITE_TRANSFER_LINK;

export const TransferHelper = {
  isInvalid(status: TransferStatus) {
    return status === TransferStatus.invalid;
  },
  isCreated(status: TransferStatus) {
    return status === TransferStatus.created;
  },
  isAllowed(status: TransferStatus) {
    return status === TransferStatus.allowed;
  },
  isRefused(status: TransferStatus) {
    return status === TransferStatus.refused;
  },
  isTransferring(status: TransferStatus) {
    return status === TransferStatus.transferring;
  },
  isArrived(status: TransferStatus) {
    return status === TransferStatus.arrived;
  },
  isArrivedWithRightAmount(status: TransferStatus) {
    return status === TransferStatus.arrived_with_right_amount;
  },
  isArrivedWithWrongAmount(status: TransferStatus) {
    return status === TransferStatus.arrived_with_wrong_amount;
  },
  isCheckedAndAllowed(status: TransferStatus) {
    return status === TransferStatus.checked_and_allowed;
  },
  isCheckedAndRefused(status: TransferStatus) {
    return status === TransferStatus.checked_and_refused;
  },
  isExpired(status: TransferStatus) {
    return status === TransferStatus.expired;
  },
  isArrivedWithWrongAmountAndMuted(status: TransferStatus) {
    return status === TransferStatus.arrived_with_wrong_amount;
  },
  isInsufficient(status: TransferStatus) {
    return (
      status === TransferStatus.dist_insufficient ||
      status === TransferStatus.recv_insufficient
    );
  },
  isExcessive(status: TransferStatus) {
    return (
      status === TransferStatus.dist_daily_excessive ||
      status === TransferStatus.recv_daily_excessive ||
      status === TransferStatus.dist_weekly_excessive ||
      status === TransferStatus.recv_weekly_excessive ||
      status === TransferStatus.dist_monthly_excessive ||
      status === TransferStatus.recv_monthly_excessive
    );
  },
  isErroredWithUnknownReason(status: TransferStatus) {
    return status === TransferStatus.errored_with_unknown_reason;
  },
  isErroredWithTransactionFailure(status: TransferStatus) {
    return status === TransferStatus.errored_with_transaction_failure;
  },
  getAddressLink(data: string) {
    return transferLink + "/#/address/" + data;
  },
  getAddressTransfersLink(data: string) {
    return transferLink + "/#/address/" + data + "/transfers";
  },
  getTransactionLink(data?: string) {
    if (!data) return "";
    return transferLink + "/#/transaction/" + data;
  },
};

export const TransferClassHelper = {
  getStatusColor(status: TransferStatus) {
    return cls({
      "fg:primary": TransferHelper.isCreated(status),
      "fg:secondary": TransferHelper.isAllowed(status),
      "fg:success":
        TransferHelper.isArrived(status) ||
        TransferHelper.isArrivedWithRightAmount(status) ||
        TransferHelper.isCheckedAndAllowed(status),
      "fg:error":
        TransferHelper.isRefused(status) ||
        TransferHelper.isArrivedWithWrongAmount(status) ||
        TransferHelper.isCheckedAndRefused(status) ||
        TransferHelper.isInsufficient(status) ||
        TransferHelper.isExcessive(status) ||
        TransferHelper.isErroredWithUnknownReason(status) ||
        TransferHelper.isErroredWithTransactionFailure(status),
      "fg:disabled":
        TransferHelper.isInvalid(status) || TransferHelper.isExpired(status),
    });
  },
};

export const TransferRoundHelper = {
  round(amount: number, round: TransferCalcRound) {
    switch (round) {
      case TransferCalcRound.roundUpToInt:
        return Math.ceil(amount * 1) / 1;
      case TransferCalcRound.roundUpToDime:
        return Math.ceil(amount * 10) / 10;
      case TransferCalcRound.roundUpToCent:
        return Math.ceil(amount * 100) / 100;
      case TransferCalcRound.roundOffToInt:
        return amount.toFixed(0);
      case TransferCalcRound.roundOffToDime:
        return amount.toFixed(1);
        break;
      case TransferCalcRound.roundOffToCent:
        return amount.toFixed(2);
        break;
      case TransferCalcRound.roundDownToInt:
        return Math.floor(amount * 1) / 1;
      case TransferCalcRound.roundDownToDime:
        return Math.floor(amount * 10) / 10;
      case TransferCalcRound.roundDownToCent:
        return Math.floor(amount * 100) / 100;
    }
  },
};
